import { media } from 'styled-bootstrap-grid'
import styled from 'styled-components'
import { ReactComponent as OTGLogo } from './assets/ocean.svg'

export const Container = styled.div`
  display: flex;
  justify-content: center;
  flex-shrink: 0;
  z-index: 1;

  ${({ theme }) => `
    padding:
      ${theme.space.desktop.huge}
      ${theme.space.desktop.small}
      ${theme.space.desktop.small};
  `}

  ${({ theme }) => media.sm`
    padding-top: calc(${theme.space.desktop.large} * 2);
  `}
`

export const Logo = styled(OTGLogo)`
  width: 150px;

  g {
    fill: ${({ theme }) => theme.color.white};
  }
`

export const CustomLogoImage = styled.img`
  max-width: 263px;
  max-height: 81px;
`
